import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from '../../features/theme/settings';
import { StyledNotificationComponent } from '../../features/notification';

interface NotificationBanner {
    message: string;
    onClose?: () => void;
}

const NotificationBanner = ({ message, onClose }: NotificationBanner) => {
    const NotificationComponent = StyledNotificationComponent(colors.system.warn.bg, colors.system.warn.text, {
        '@media (maxWidth: 600px)': {
            maxWidth: '100%',
            minWidth: '100%',
        },
    });

    return (
        <NotificationComponent>
            <InfoOutlinedIcon sx={{ marginRight: '8px', color: colors.system.warn.main }} />
            <Box sx={{ flexGrow: 1 }}>{message}</Box>
            {onClose && (
                <IconButton size='small' aria-label='close' color='inherit' onClick={onClose} sx={{ height: '100%' }}>
                    <CloseIcon fontSize='small' />
                </IconButton>
            )}
        </NotificationComponent>
    );
};

export default NotificationBanner;
